// extracted by mini-css-extract-plugin
module.exports = {"row":"_-_-pharmacy-src-display-table-base-baseTableHeader__row--35SL6"};